export default "__VITE_ASSET__Iv7oFu4K__"